import { useMemo, useId as useReactId } from "react";
var idCounter = {};
export var useUniquePrefix = function() {
    var label = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'cv';
    if (useReactId) {
        return label + useReactId();
    }
    return useMemo(function() {
        if (!idCounter[label]) {
            idCounter[label] = 0;
        }
        var count = idCounter[label]++;
        return "".concat(label, "-").concat(count);
    }, [
        label
    ]);
};
export default useUniquePrefix;
